module.exports = __webpack_public_path__ + "static/media/eventival.9c7c91eb.png";